import React from "react";
import { Modal } from "react-bootstrap";

const PopupModal = ({ ...props }) => {
  const { title, popupShow, setPopupShow, children } = props;

  return (
    <Modal
      show={popupShow}
      onHide={() => setPopupShow(false)}
      centered
      // backdrop="static"
      // keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default PopupModal;
